import { render, staticRenderFns } from "./color-section.global.vue?vue&type=template&id=3abeb6ce&"
import script from "./color-section.global.vue?vue&type=script&lang=js&"
export * from "./color-section.global.vue?vue&type=script&lang=js&"
import style0 from "./color-section.global.vue?vue&type=style&index=0&id=3abeb6ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports